import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { BeforeAfter } from './components/BeforeAfter';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { Extras } from './components/Extras';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { About } from './components/About';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
export function App({
  showPurchasePopup = true
}: {
  showPurchasePopup?: boolean;
}) {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="23ut97wmn5o7m">
      <MetaPixel data-id="element-1" data-mp="3ijxsgzk2wgo4" />
      <main className="w-full" data-id="element-2" data-mp="3ikh5c1uvgeva">
        <Hero data-id="element-3" data-mp="3ijfvu1ti80fo" />
        <ProblemSection data-id="element-4" data-mp="3ijpef4c7z5bc" />
        <BeforeAfter data-id="element-5" data-mp="3mlj98vzqhf3l" />
        <PainPoints data-id="element-6" data-mp="3mkrd9k285fcs" />
        <Volumes data-id="element-7" data-mp="3mk868ye44bdj" />
        <Extras data-id="element-8" data-mp="3mjq2lgp4euvl" />
        <Bonuses data-id="element-9" data-mp="3mj6hjr46bqdc" />
        <Offer data-id="element-10" data-mp="3rcj6y3gog175" />
        <Guarantee data-id="element-11" data-mp="3rbzn2h7gv2qh" />
        <Testimonials data-id="element-12" data-mp="3rdkisa5iorpx" />
        <About data-id="element-13" data-mp="3rd18nfm3z7mg" />
        <Faq data-id="element-14" data-mp="3relv0hy9rk98" />
        <FinalCta data-id="element-15" data-mp="5ot150vj28n" />
      </main>
      <Footer data-id="element-16" data-mp="4wxfu7a14id" />
      <FloatingCta data-id="element-17" data-mp="5gel8p3rovc" />
      {showPurchasePopup && <PurchasePopup data-id="element-18" data-mp="2zl3brl12165b" />}
    </div>;
}